import { render } from "./CoreDrag.vue?vue&type=template&id=023e27ce"
import script from "./CoreDrag.vue?vue&type=script&lang=js"
export * from "./CoreDrag.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__